import styled from 'react-emotion';

import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import BaseIconButton from '@material-ui/core/IconButton';
import BaseButton from '@material-ui/core/Button';
import BaseDialogTitle from '@material-ui/core/DialogTitle';
import BaseDialogContent from '@material-ui/core/DialogContent';
import BaseDialogActions from '@material-ui/core/DialogActions';

export const DialogTitle = styled(BaseDialogTitle)`
  padding-left: 8px;
  padding-top: 8px;
  padding-bottom: 0px;
`;

export const DialogContent = styled(BaseDialogContent)`
  padding: 0px;
`;

export const DialogActions = styled(BaseDialogActions)`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  margin: 0px;
  padding-bottom: 14px;
  padding-right: 8px;
`;

export const TitleButton = styled(BaseIconButton)`
  border-radius: 4px;
  padding: 0px;
  color: ${colors.grey11};
  :hover {
    background-color: ${colors.grey0};
  }
  :focus {
    background-color: ${colors.grey3};
  }
`;

export const Button = styled(BaseButton)`
  margin-left: 16px;
  text-transform: none;
  color: ${colors.green};
`;
